(() => {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || !this.dataset.url) return;
      this.dataset.loaded = 'true';

      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
          return response.text();
        })
        .then((text) => {
          const documentFragment = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = documentFragment.querySelector('product-recommendations');
          if (recommendations?.innerHTML.trim()) {
            this.innerHTML = recommendations.innerHTML;
            this.hidden = false;
          } else {
            this.hidden = true;
          }
        })
        .catch(() => {
          this.hidden = true;
        });
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
})();
